$(() => {
  const statusEl = document.querySelectorAll("[data-js-status]")

  fetch("./static/status.json", { credentials: "include" })
    .then((response) => response.json())
    .then((data) => {
      $(document).on("progress:stop", () => {
        statusEl.forEach((el) => {
          const type = el.dataset.jsStatus
          if (data[type]) {
            el.classList.add("_done")
          }
        })
      })
    })
    .catch(() => {
      /**/
    })
})



// WEBPACK FOOTER //
// ./src/blocks/progress-cards/status.js